import TR from 'utils/TR';
import { Chart } from 'chart.js';
import AbnormalCircle from 'components/common/AbnormalCircle';
import HBox from 'components/common/HBox';
import Segment from 'components/common/Segment';
import VBox from 'components/common/VBox';
import useRect from 'hooks/common/useRect';
import React from 'react';
import T from 'utils/T';
import ex from 'utils/ex';
import { numberWithComma } from 'utils/number';
import HalfDoughnutChart from '../../charts/HalfDoughnutChart';
import DoubleBarChart from '../../charts/DoubleBarChart';
import Dot from 'components/common/Dot';

export default function DietBox(props) {
  const {
    data,
    ...rest
  } = props || {};

  const {
    bad_food_name = '',
    abnormal_ocurr_rate = 0,
    daily_avg_total_intake = 0,
    daily_avg_carbo_intake = 0,
    daily_avg_carbo_intake_rate = 0,

    bf_day_avg_intake_cal = 0,
    bf_day_avg_carbo_amt = 0,

    recommend_avg_intake_cal = 0,
    recommend_carbo_avg_intake_amt = 0,
  } = data || {};

  const [calories, calories_min, calories_max] = React.useMemo(() => {
    return [
      [[{ label: 'last', value: bf_day_avg_intake_cal }], [{ label: 'average', value: daily_avg_total_intake }]],
      Math.min(recommend_avg_intake_cal, bf_day_avg_intake_cal, daily_avg_total_intake),
      Math.max(recommend_avg_intake_cal, bf_day_avg_intake_cal, daily_avg_total_intake)
    ];
  }, [bf_day_avg_intake_cal, daily_avg_total_intake, recommend_avg_intake_cal]);

  const [carbohydrate, carbohydrate_min, carbohydrate_max] = React.useMemo(() => {
    return [
      [[{ label: 'last', value: bf_day_avg_carbo_amt }], [{ label: 'average', value: daily_avg_carbo_intake }]],
      Math.min(recommend_carbo_avg_intake_amt, bf_day_avg_carbo_amt, daily_avg_carbo_intake),
      Math.max(recommend_carbo_avg_intake_amt, bf_day_avg_carbo_amt, daily_avg_carbo_intake),
    ];
  }, [bf_day_avg_carbo_amt, daily_avg_carbo_intake, recommend_carbo_avg_intake_amt]);

  return (
    <Segment {...ex(['OverviewBox', 'DietBox'], props)}>
      <HBox full>
        <VBox
          {...ex('BoxContainer')}
        >
          <div>
            <div {...ex('BoxItem')}>
              {T('이상혈당 유발 음식')}
            </div>
            <HBox {...ex('BoxValueContainer')}>
              {(bad_food_name || '').split(',').map(text => (
                <div
                  key={text}
                  {...ex('BoxValue')}
                >
                  {text}
                </div>
              ))}
            </HBox>
          </div>
          <div>
            <div {...ex('BoxItem')}>
              {T('식후 이상혈당 발생')}
            </div>
            <HBox {...ex('BoxValueContainer')}>
              <div {...ex('BoxValue')}>
                {numberWithComma(abnormal_ocurr_rate)}
              </div>
              <div {...ex('BoxUnit')}>
                {T('%')}
              </div>
            </HBox>
          </div>
        </VBox>
        <VBox full>
          <HBox {...ex('OverviewBoxLegends')}>
            <Dot {...{ color: '#ff995a' }}>
              <div>
                {T('일권장량')}
              </div>
            </Dot>
            <Dot {...{ color: '#AAAAAA' }}>
              <div>
                {T('지난 기간')}
              </div>
            </Dot>
            <Dot {...{ color: '#1D82FF' }}>
              <div>
                {T('일평균')}
              </div>
            </Dot>
          </HBox>
          <HBox full>
            <VBox full>
              <DoubleBarChart
                {...{
                  max: calories_max < carbohydrate_max ? (calories_max + carbohydrate_max) / 2 : calories_max,
                  min: calories_min * 0.9,
                  values: calories,
                  recommended: recommend_avg_intake_cal,
                  unit: T('kcal'),
                }}
              />
              <div {...ex('ChartLabel')}>
                {T('섭취칼로리 (kcal)')}
              </div>
            </VBox>
            <VBox full>
              <DoubleBarChart
                {...{
                  max: calories_max > carbohydrate_max ? (calories_max + carbohydrate_max) / 2 : calories_max,
                  min: carbohydrate_min * 0.9,
                  values: carbohydrate,
                  recommended: recommend_carbo_avg_intake_amt,
                  unit: T('g'),
                }}
              />
              <div {...ex('ChartLabel')}>
                {T('탄수화물 (g)')}
              </div>
            </VBox>
          </HBox>
        </VBox>
      </HBox>
    </Segment>
  );
}
